import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import AppSection from '@/pages/home/components/AppSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import ContactSection from '@/pages/home/components/ContactSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CardsSection from '@/pages/home/components/CardsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AboutSection from '@/pages/home/components/AboutSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <FeaturesSection />
        <MediaSection />
        <CommentsSection />
        <IndexSection />
        <ContactSection />
        <TopicsSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <FaqSection />
        <CarouselSection />
        <AboutSection />
      </main>

      <Footer />
    </div>
  );
}